/**
 * @generated SignedSource<<6e6eb1ac74ebe92c5b0b102fe4f3f29f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FavoritesItem_item$data = {
  readonly ecommerceTrackingParams: any | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "FavoritesItem_item";
};
export type FavoritesItem_item$key = {
  readonly " $data"?: FavoritesItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ecommerceTrackingParams",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5b7ddcf72ba93cb5f190df1654c7b257";

export default node;
